import Crud from '../views/Unit/Crud'
import Entity from '../views/Unit/Add'

let routes = {
    path: '/units',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/units/add',
            name: 'NewUnit',
            component: Entity,
            meta: {
                ability: 'unidades.gerenciar',
                pageTitle: 'Unit',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/units'
                    },
                    {
                        text: 'Add',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/units/edit/:id?',
            name: 'EditUnit',
            component: Entity,
            meta: {
                ability: 'unidades.gerenciar',
                pageTitle: 'Unit',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/units'
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/units',
            name: 'list-units',
            component: Crud,
            meta: {
                ability: 'unidades.ver',
                pageTitle: 'Units',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
